import React, { useState } from 'react';
import { Button, Header, Input } from '../../components';
import Loading from '../../components/Loading';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../../contexts/ContextProvider';
import axiosClient from '../../axios-client';
import Alert from '../../components/Alert';
import { toast } from 'react-toastify';
import { GiCancel } from 'react-icons/gi';
import { IoIosSave } from 'react-icons/io';
import Select from 'react-select';

const AddExamen = ({ onClose }) => {
    const [loading, setLoading] = useState(false);

    const { token, setToken } = useStateContext();
    const [errors, setErrors] = useState(null);
    const [classes, setClasses] = useState([]);
    const [selectedClasse, setSelectedClasse] = useState(null);
    const [inputValueClasse, setValueClasse] = useState('');

    const [matieres, setMatieres] = useState([]);
    const [selectedMatiere, setSelectedMatiere] = useState(null);
    const [inputValueMatiere, setValueMatiere] = useState('');

    const [trimestres, setTrimestres] = useState([]);
    const [selectedTrimestre, setSelectedTrimestre] = useState(null);
    const [inputValueTrimestre, setValueTrimestre] = useState('');

    const [enseignants, setEnseignant] = useState([]);
    const [selectedEnseignant, setSelectedEnseignant] = useState(null);
    const [inputValueEnseignant, setValueEnseignant] = useState('');


    const [examen, setExamen] = useState({
        classe: '',
        matiere: '',
        heureDebut: null,
        heureFin: null,
        enseignant: null,
        dateExamen: null,
        trimestre: null

    });

    const handleInputChangeClasse = value => {
        setValueClasse(value);
    };

    // handle selection


    // handle selection
    const handleChangeMatiere = value => {
        setSelectedMatiere(value);
        setExamen({ ...examen, matiere: value.id });

    }

    const handleInputChangeMatiere = value => {
        setValueMatiere(value);
    };

    // handle selection

    const handleChangeTrimestre = value => {
        setSelectedTrimestre(value);
        setExamen({ ...examen, trimestre: value.id });


    }

    const handleInputChangeTrimestre = value => {
        setValueTrimestre(value);
    };


    const handleChangeEnseignant = value => {
        setSelectedEnseignant(value);
        setExamen({ ...examen, enseignant: value.id });


    }

    const handleInputChangeEnseignant = value => {
        setValueEnseignant(value);
    };
    // handle selection
    const handleChangeClasse = value => {
        setSelectedClasse(value);
        setExamen({ ...examen, classe: value.id });
        setLoading(true);
        getMatieres(value.groupe_id);
        setLoading(false);

    }


    const navigate = useNavigate();
    const getMatieres = (groupe_id) => {
        axiosClient.get('/classe/matieres/' + groupe_id)
            .then((data) => {
                setMatieres(data.data.matieres);
            }).catch(err => {
                navigate('/500');
            })
    }

    const getClasses = () => {
        axiosClient.get('/classes')
            .then((data) => {
                setClasses(data.data.classes);
            }).catch(err => {
                navigate('/500');
            })
    }

    const getEnseignants = () => {
        axiosClient.get('/enseignants')
            .then((data) => {
                setEnseignant(data.data.enseignants);
            }).catch(err => {
                navigate('/500');
            })
    }

    const getTrimestres = () => {
        axiosClient.get('/trimestres')
            .then((data) => {
                setTrimestres(data.data.trimestres);
            }).catch(err => {
                navigate('/500');
            })
    }

    useEffect(() => {
        setLoading(true);
        getClasses();
        getTrimestres();
        getEnseignants();
        setLoading(false);
    }, []);
    const onSubmit = () => {

        setErrors(null);
        setLoading(true);

        axiosClient.post('/examen/save', examen)
            .then((response) => {
                setLoading(false);
                setErrors(null);
                toast.success('Opération effectuée avec succès!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                onClose();
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Merci de verifier les informations a saisies!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }



    return (
        <>
            <div className=' fixed inset-0 h-full bg-black bg-opacity-25 backdrop-blur-sm  '>
                <div className='h-screen flex justify-center items-center'>
                    <div className='flex-col w-1/2 bg-white lg:p-10 xl:p-10   p-2 md:p-10  rounded-xl'>
                        <div className=''>
                            <Header title="Ajouter un examen" />
                        </div>
                        {errors &&
                            Object.keys(errors).map(key => (
                                <Alert key={key} message={errors[key][0]} />
                            ))
                        }
                        {loading ? <Loading /> :
                            <>
                                <div className='flex flex-wrap md:flex-nowrap lg:flex-nowrap xl:flex-nowrap gap-2'>
                                    <div className='flex-col w-full justify-evenly '>
                                        <div className='mr-2'>
                                            <Input label="Date" type="date" value={examen.dateExamen} onChange={ev => setExamen({ ...examen, dateExamen: ev.target.value })} required="required" />
                                        </div>
                                        <div className="flex-col w-full">
                                            <label className="block text-sm font-medium leading-6 text-gray-900">Classe <span className='text-red-500'> *</span></label>
                                            <Select className='mt-2 outline-1 ' placeholder="Classe" cacheOptions defaultOptions value={selectedClasse} getOptionLabel={e => e.libelle} getOptionValue={e => e.id} options={classes} onInputChange={handleInputChangeClasse} onChange={handleChangeClasse} />
                                        </div>
                                        <div className="flex-col w-full">
                                            <label className="block text-sm font-medium leading-6 text-gray-900">Matiere <span className='text-red-500'> *</span></label>
                                            <Select className='mt-2 outline-1 ' placeholder="Matiere" cacheOptions defaultOptions value={selectedMatiere} getOptionLabel={e => e.matiere} getOptionValue={e => e.id} options={matieres} onInputChange={handleInputChangeMatiere} onChange={handleChangeMatiere} />
                                        </div>
                                        <div className="flex-col w-full">
                                            <label className="block text-sm font-medium leading-6 text-gray-900">Enseignant <span className='text-red-500'> *</span></label>
                                            <Select className='mt-2 outline-1 ' placeholder="Enseignant" cacheOptions defaultOptions value={selectedEnseignant} getOptionLabel={e => e.nomTel} getOptionValue={e => e.id} options={enseignants} onInputChange={handleInputChangeEnseignant} onChange={handleChangeEnseignant} />
                                        </div>
                                    </div>
                                    <div className='flex-col w-full justify-evenly '>

                                        <div className="flex-col w-full">
                                            <label className="block text-sm font-medium leading-6 text-gray-900">Trimestre <span className='text-red-500'> *</span></label>
                                            <Select className='mt-2 outline-1 ' placeholder="Trimestre" cacheOptions defaultOptions value={selectedTrimestre} getOptionLabel={e => e.code} getOptionValue={e => e.id} options={trimestres} onInputChange={handleInputChangeTrimestre} onChange={handleChangeTrimestre} />
                                        </div>
                                        <div className='mr-2'>
                                            <Input label="Heure Debut" type="time" value={examen.heureDebut} onChange={ev => setExamen({ ...examen, heureDebut: ev.target.value })} required="required" />
                                        </div>
                                        <div className='mr-2'>
                                            <Input label="Heure Fin" type="time" value={examen.heureFin} onChange={ev => setExamen({ ...examen, heureFin: ev.target.value })} required="required" />
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                        <div className='flex  justify-end items-end'>
                            <div className=' flex gap-3 m-2  justify-between'>
                                <Button icon={<IoIosSave />} onClick={onSubmit} color="ml-1 bg-green-500" textColor="text-white" text="Enregistrer" />
                                <Button icon={<GiCancel />} onClick={() => onClose()} color="bg-red-500" textColor="text-white" text="Fermer" />
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default AddExamen